import { Tags } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  TAG_SCOPES,
  TAG_SCOPE_LABELS,
  availableTagScopes,
  shownTagScope,
  type ScopedTag,
  type TagScope,
} from "@/lib/tagScope";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

/** The tag row's choice, as native: the one in effect checked, choices without tags greyed out. */
export function TagScopeMenu({
  value,
  onChange,
  tags,
}: {
  value: TagScope;
  onChange: (scope: TagScope) => void;
  tags: ScopedTag[];
}) {
  const choices = availableTagScopes(tags);
  const shown = shownTagScope(value, tags);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon-control"
          aria-label={`Tags: ${TAG_SCOPE_LABELS[shown]}`}
          title={`Tags: ${TAG_SCOPE_LABELS[shown]}`}
        >
          <Tags aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup value={shown} onValueChange={next => onChange(next as TagScope)}>
          {TAG_SCOPES.map(scope => (
            <DropdownMenuRadioItem key={scope} value={scope} disabled={!choices.includes(scope)}>
              {TAG_SCOPE_LABELS[scope]}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
